import { render, staticRenderFns } from "./interaction.vue?vue&type=template&id=38d39f49&scoped=true&"
import script from "./interaction.vue?vue&type=script&lang=js&"
export * from "./interaction.vue?vue&type=script&lang=js&"
import style0 from "./interaction.vue?vue&type=style&index=0&id=38d39f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d39f49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VFlex,VIcon,VSelect,VTextField})
